// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabs[data-v-2930869e] {\n  position: relative;\n}\n.tabs .headerTabs[data-v-2930869e] {\n  border-bottom: 1px solid #f5f5f5;\n}\n.tabs .item[data-v-2930869e] .el-badge__content {\n  min-width: 18px;\n}\n.tabs .rightCont[data-v-2930869e] {\n  position: absolute;\n  right: 24px;\n  top: 12px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
